import PropTypes from 'prop-types';
import { screen, colors } from 'components/styles/variables';

const Heading = ({ title, dark, className = '' }) => (
  <h2 className={className}>
    <span>{title}</span>

    <style jsx>{`
      h2 {
        position: relative;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 20px;
        text-align: center;
        letter-spacing: 0.3px;
        ${dark ? 'color: white;' : ''};
      }
      h2:before {
        content: '';
        display: block;
        border-top: ${dark ? 'solid 1px white' : `solid 1px ${colors.G2}`};
        width: 100%;
        height: 1px;
        position: absolute;
        top: 50%;
        z-index: 1;
      }
      h2 span {
        padding: 0px 10px;
        position: relative;
        z-index: 5;
        background-color: ${dark ? colors.BLACK : 'white'};
      }

      @media (min-width: ${screen.lgMin}) {
        h2 {
          font-size: 22px;
        }
      }
    `}</style>
  </h2>
);

Heading.propTypes = {
  title: PropTypes.string.isRequired,
  dark: PropTypes.bool,
  className: PropTypes.string,
};

export default Heading;
